<script setup lang="ts">
import BannerCarousel from './BannerCarousel.vue';
import LandingBanner from './LandingBanner.vue';

const contentStore = useContentStore();
const {
    homepageFilteredBanners,
    homepageFilteredSliders,
    homepageMessagesLoading,
} = classToRefs(contentStore);
const route = useRoute();
const { isMobile } = useSize();
const show = computed(
    () =>
        homepageFilteredBanners.value.length > 0 ||
        homepageFilteredSliders.value.length > 0 ||
        homepageMessagesLoading.value
);
const banners = computed(() =>
    homepageFilteredBanners.value
        .filter(m => new RegExp(m.urlPattern || '').test(route.path))
        .filter(
            m =>
                !m.displaySize ||
                m.displaySize === 'both' ||
                (m.displaySize === 'mobile' ? isMobile.value : !isMobile.value)
        )
);
const sliders = computed(() =>
    homepageFilteredSliders.value
        .map(sliders =>
            sliders
                .filter(m => new RegExp(m.urlPattern || '').test(route.path))
                .filter(
                    m =>
                        !m.displaySize ||
                        m.displaySize === 'both' ||
                        (m.displaySize === 'mobile'
                            ? isMobile.value
                            : !isMobile.value)
                )
        )
        .filter(sliders => sliders.length)
);
</script>

<template>
    <div v-show="show" class="landing-banners-wrapper">
        <div class="landing-banners-container">
            <BannerCarousel
                v-for="(slider, sliderIndex) in sliders"
                :key="`slider-${sliderIndex}`"
                :items="slider"
            />
            <LandingBanner
                v-for="banner in banners"
                :id="`banner-click-${banner.id}`"
                :key="banner.id"
                :banner
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.landing-banners-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding-top: 0;
    padding-bottom: 20px;
}

.landing-banners-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: $app-container-max-width;
}

@media (max-width: ($app-container-max-width + 32px)) {
    .landing-banners-wrapper {
        padding-right: 16px;
        padding-left: 16px;
    }
}
</style>
